import React, { useEffect, useRef, useState } from "react";
import { Header } from "../header";
import { Footer } from "../footer";
import { Button, Input, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import "./contactUs.css"
import callIcon from "../../../src/assets/images/c5.svg"
import mailIcon from "../../../src/assets/images/c6.svg"
import addressIcon from "../../../src/assets/images/c4.svg"
import {baseUrl} from "../../../src/config"
import Back3 from "../../../src/assets/images/back3.webp";
import { WhatsappIcon } from "../overlay/whatsapp";
import greyImage from '../../assets/images/always-grey.png';
export const ContactUs = () => {
    const [inputReq, setInputReq] = useState({
        name: "",
        mobile: "",
        email: "",
        subject: "", description: ""
    })
 const headerRef:any=useRef();
      useEffect(()=>{
          headerRef?.current?.scrollIntoView({ behavior: 'smooth' });
      },[])
    const handleSubmit = async () => {
        // Check if all fields in formData are filled
        const allFieldsFilled = Object.values(inputReq).every(value => {
          // Only trim if the value is a string
          return typeof value === 'string' ? value.trim() !== "" : value !== undefined && value !== null;
        });
      
        if (allFieldsFilled) {
          // If all fields are filled, log the form data and close the modal
          console.log("Form values:", inputReq);
          try {
            const resp = await axios.post(
              `${baseUrl}enquiry/add`, inputReq
            );
            console.log(resp.data); // Log the response to check
            if (resp?.data) {
                setInputReq({
                    name: "",
                    mobile: "",
                    email: "",
                    subject: "", description: ""  
                })
              message.success("Team will get back to you soon")
            }
          } catch (e) {
            console.error(e);
          }
      
        } else {
          // If any field is empty, show a warning message
          message.error("Please fill in all fields before submitting.");
        }
      };
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
            backgroundColor: "#ffffff",
            color: "#000000",
             backgroundImage: `url(${greyImage})`
        }} 
        className="contacts-container"
        ref={headerRef}
        >
            <Header />
            <div style={{
                    backgroundImage: `url(${Back3})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    fontSize: '40px',
                    fontWeight: '500',
                    color: 'white',
                    padding: '60px 20px',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                CONTACT US
                </div>
                 <div style={{ width: "100%", borderBottom: "5px solid #e53535", textAlign: "center", marginBottom: 60 }}></div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"80%",flexDirection:"column"}}>
        {/* <div style={{
                    backgroundImage: `url(${Back3})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    fontSize: '40px',
                    fontWeight: '500',
                    color: 'white',
                    padding: '60px 20px',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                CONTACT US
                </div> */}
        {/* <div style={{ width: "80%", borderBottom: "1px solid #575555", textAlign: "center", marginBottom: 60 }}></div> */}
          <div className="contactus-container">
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", textAlign: "left", fontSize: 28,width: window.innerWidth>1000 ?"60%":"90%" }}>
                    <div>
                        <div><img style={{width:45,height:45}}  src={addressIcon}></img></div>
                        <ul style={{ width: "70%", fontSize: 20,padding:0 }}>
                              <div style={{display:"flex",justifyContent:"center",gap:10}}>
                            
                                                       <div>#79-3F, Pillyar Koil Street, Puliyambeadu, Vellapanchavadi
Chennai, Tamilnadu, India-600077</div>
                            </div>
                        </ul>
                    </div>
                    <div>
                       <div><img style={{width:45,height:45}} src={callIcon}></img></div>
                        <ul style={{ fontSize: 20 ,padding:0}}>
                            <div style={{display:"flex",alignItems:"center",flexDirection:"column",justifyContent:"center",gap:10}}>
                            <div>+91-9445979137</div>
                            </div>
                            
                        </ul>
                    </div>
                    <div>
                      <div><img style={{width:45,height:45}}  src={mailIcon}></img></div>
                        <ul style={{ fontSize: 20,padding:0 }}>
                        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10}}>
                        
                            <div>ram@geesendeavour.com</div>
                            </div>
                        </ul>
                    </div>
                </div>
                <div className="contact-form">
                    <div style={{ fontSize: 28 }}>Contact Us</div>
                    <div className="contact-group">
                        <div>Name</div>
                        <div><Input value={inputReq.name} onChange={(e)=>setInputReq({...inputReq,name:e.target.value})}></Input></div>
                    </div>
                    <div className="contact-group">
                        <div>Phone</div>
                        <div><Input value={inputReq.mobile} onChange={(e)=>setInputReq({...inputReq,mobile:e.target.value})}></Input></div>
                    </div>
                    <div className="contact-group">
                        <div>Email</div>
                        <div><Input value={inputReq.email}  onChange={(e)=>setInputReq({...inputReq,email:e.target.value})}></Input ></div>
                    </div>
                    <div className="contact-group">
                        <div>Subject</div>
                        <div><Input value={inputReq.subject}  onChange={(e)=>setInputReq({...inputReq,subject:e.target.value})}></Input></div>
                    </div>
                    <div className="contact-group">
                        <div>Description</div>
                        <div><TextArea value={inputReq.description}  style={{ width: "183px" }} onChange={(e)=>setInputReq({...inputReq,description:e.target.value})}></TextArea></div>
                    </div>
                    <Button style={{ width: "80%", background: "#273975", borderRadius: 12, border: "1px solid #273975", color: "#000000", fontWeight: 600, fontSize: 20 }}
                    onClick={handleSubmit}>Submit</Button>
                </div>
            </div>
        </div>
          <WhatsappIcon/>
            <Footer />
        </div>
    )
}